import type { Transition, Variants } from 'framer-motion';

export const REFLEX_ENTER_SPRING: Transition = {
  type: 'spring',
  stiffness: 380,
  damping: 22,
  mass: 0.7,
};

export const REFLEX_EXIT_TWEEN: Transition = {
  duration: 0.15,
  ease: 'easeIn',
};

export const reflexCardVariants: Variants = {
  initial: { opacity: 0, scale: 0.97, y: 8 },
  animate: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: REFLEX_ENTER_SPRING,
  },
  exit: {
    opacity: 0,
    scale: 0.98,
    transition: REFLEX_EXIT_TWEEN,
  },
};

export const REFLEX_STEP_REVEAL_STAGGER = 0.14;
export const REFLEX_STEP_REVEAL_OFFSET = 40;

const REFLEX_STEP_RISE_SPRING: Transition = {
  type: 'spring',
  stiffness: 220,
  damping: 12,
  mass: 0.85,
};

const REFLEX_STEP_FADE: Transition = {
  duration: 0.28,
  ease: 'easeOut',
};

export const reflexStepRevealVariants: Variants = {
  initial: { opacity: 0, y: REFLEX_STEP_REVEAL_OFFSET },
  animate: (index?: number) => {
    const delay =
      typeof index === 'number' ? index * REFLEX_STEP_REVEAL_STAGGER : 0;
    return {
      opacity: 1,
      y: 0,
      transition: {
        opacity: { ...REFLEX_STEP_FADE, delay },
        y: { ...REFLEX_STEP_RISE_SPRING, delay },
      },
    };
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.15, ease: 'easeIn' },
  },
};
